import "./LabelledReadOnlyField.scss";

interface LabelledReadOnlyFieldProps {
    label: string;
    value: string;
}

const LabelledReadOnlyField = (props: LabelledReadOnlyFieldProps) => {
    return (
        <div className="labelled-read-only-field">
            <label className="labelled-read-only-field-name">{props.label}</label>
            <input type="text" readOnly className="labelled-read-only-field-value" value={props.value} />
        </div>
    );
}

export default LabelledReadOnlyField;